export default __webpack_public_path__ + "static/media/blackTicket@3x.541ce891.png";